import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon, CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
export function TrustSection() {
  return <section className="py-20 md:py-28 bg-navy relative overflow-hidden" data-id="element-63">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-navy-light/20 blur-3xl rounded-full pointer-events-none" data-id="element-64" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="max-w-2xl mx-auto text-center" data-id="element-66">
          {/* Shield Icon */}
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-emerald-500/10 mb-8" data-id="element-67">
            <ShieldCheckIcon className="w-10 h-10 text-emerald-500" data-id="element-68" />
          </div>

          {/* Headline */}
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-6" data-id="element-69">
            Confianza Total o te devolvemos tus $6.39
          </h2>

          {/* Body */}
          <p className="font-sans text-lg text-white/80 mb-12 leading-relaxed" data-id="element-70">
            Garantía de devolución de 7 días. Cero riesgo. Si no ves resultados,
            recuperas cada centavo.
          </p>

          {/* Trust Badges */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8 mb-12" data-id="element-71">
            <div className="flex items-center gap-2 text-white/90" data-id="element-72">
              <LockIcon className="w-5 h-5 text-emerald-500" data-id="element-73" />
              <span className="font-medium" data-id="element-74">Pago 100% Seguro</span>
            </div>
            <div className="hidden sm:block w-1 h-1 rounded-full bg-white/20" data-id="element-75" />
            <div className="flex items-center gap-2 text-white/90" data-id="element-76">
              <CheckCircleIcon className="w-5 h-5 text-emerald-500" data-id="element-77" />
              <span className="font-medium" data-id="element-78">Garantía 7 Días</span>
            </div>
            <div className="hidden sm:block w-1 h-1 rounded-full bg-white/20" data-id="element-79" />
            <div className="flex items-center gap-2 text-white/90" data-id="element-80">
              <ArrowRightIcon className="w-5 h-5 text-emerald-500" data-id="element-81" />
              <span className="font-medium" data-id="element-82">Acceso Inmediato</span>
            </div>
          </div>

          {/* Final CTA */}
          <div className="flex flex-col items-center" data-id="element-83">
            <motion.a href="https://protocolzenith.com/products/renta-pagada-y-deuda-cero-en-30-dias" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="relative inline-flex items-center justify-center w-full sm:w-auto px-8 py-5 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg text-lg md:text-xl font-bold shadow-[0_0_30px_rgba(16,185,129,0.4)] transition-colors duration-200 group overflow-hidden" data-id="element-84">
              {/* Shine effect */}
              <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent" data-id="element-85" />
              ACCESO INSTANTÁNEO POR $6.39 — PAGO SEGURO 💳
            </motion.a>

            <p className="mt-6 text-sm text-white/50 flex items-center gap-1.5" data-id="element-86">
              <LockIcon className="w-3.5 h-3.5" data-id="element-87" />
              Transacción encriptada y segura
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}